import { Loading } from '@affine/component';
import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import type { ReactElement } from 'react';

import { EnableCloudPanel } from '../preference/enable-cloud';
import { SettingsEntityMessage } from '../shared/settings-entity';
import { PermissionsSettingsPanel } from './permissions-panel';
import * as styles from './styles.css';

export const WorkspaceSettingPermissions = ({
  onCloseSetting,
}: {
  onCloseSetting: () => void;
}): ReactElement | null => {
  const workspace = useService(WorkspaceService).workspace;

  if (workspace.flavour === 'local') {
    return <PermissionsLocalPanel onCloseSetting={onCloseSetting} />;
  }

  return (
    <AffineErrorBoundary>
      <PermissionsSettingsPanel />
    </AffineErrorBoundary>
  );
};

const PermissionsLocalPanel = ({
  onCloseSetting,
}: {
  onCloseSetting: () => void;
}) => {
  const t = useI18n();

  return (
    <div className={styles.permissionsPanel}>
      <SettingsEntityMessage>
        {t['com.streamlain.settings.workspace.permissions.local-only']?.() ??
          'Permissions are only available for cloud workspaces.'}
      </SettingsEntityMessage>
      <EnableCloudPanel onCloseSetting={onCloseSetting} />
    </div>
  );
};

export const PermissionsPanelFallback = () => {
  const t = useI18n();

  return (
    <div className={styles.loadingState}>
      <Loading size={20} />
      <span>
        {t['com.streamlain.settings.workspace.permissions.loading']?.() ??
          'Loading permissions...'}
      </span>
    </div>
  );
};
